module.exports = {
    landcoverClasses: [
        {
            "name": "All",
            "color": [0, 0, 0, 0],
            "colorLab": [0, 0, 0],
            "id": 0
        },
        {
            "name": "Unclassified",
            "color": [1, 1, 1, 255],
            "colorLab": [0.2741734960237956, 0.00003730098721566044, -0.00007380509088883436],
            "id": 1
        },
        {
            "name": "Developed, High Intensity",
            "color": [171, 0, 0, 255],
            "colorLab": [35.31716164790645, 59.37904476315922, 49.64954217727144],
            "id": 2
        },
        {
            "name": "Developed, Medium Intensity",
            "color": [235, 0, 0, 255],
            "colorLab": [49.08376319622447, 75.308367884784, 63.19157739919342],
            "id": 3
        },
        {
            "name": "Developed, Low Intensity",
            "color": [217, 146, 130, 255],
            "colorLab": [67.21786041864921, 24.911195700463796, 19.42586542012874],
            "id": 4
        },
        {
            "name": "Developed, Open Space",
            "color": [222, 197, 197, 255],
            "colorLab": [81.56200535099418, 8.793258917611679, 3.213993023308692],
            "id": 5
        },
        {
            "name": "Cultivated Crops",
            "color": [171, 108, 40, 255],
            "colorLab": [51.30878346260846, 19.363217847411796, 46.44166375918491],
            "id": 6
        },
        {
            "name": "Pasture/Hay",
            "color": [220, 217, 57, 255],
            "colorLab": [84.55415939983308, -16.598620443633582, 73.53887346183132],
            "id": 7
        },
        {
            "name": "Grassland/Herbaceous",
            "color": [223, 223, 194, 255],
            "colorLab": [88.14080094799647, -4.877817738333567, 14.231610660552763],
            "id": 8
        },
        {
            "name": "Deciduous Forest",
            "color": [104, 171, 95, 255],
            "colorLab": [64.07588071895144, -36.59818340061549, 32.52514425934094],
            "id": 9
        },
        {
            "name": "Evergreen Forest",
            "color": [28, 95, 44, 255],
            "colorLab": [35.22852855605888, -33.14472705345628, 23.078218389244153],
            "id": 10
        },
        {
            "name": "Mixed Forest",
            "color": [181, 197, 143, 255],
            "colorLab": [77.12476884839018, -14.668221710120722, 25.33365271346979],
            "id": 11
        },
        {
            "name": "Scrub/Shrub",
            "color": [204, 184, 121, 255],
            "colorLab": [75.13846879903663, -1.7209102314360014, 34.581262976286745],
            "id": 12
        },
        {
            "name": "Palustrine Forested Wetland",
            "color": [13, 13, 13, 255],
            "colorLab": [3.6354946850715635, 0.0004946048495491073, -0.0009786431567682108],
            "id": 13
        },
        {
            "name": "Palustrine Scrub/Shrub Wetland",
            "color": [184, 217, 235, 255],
            "colorLab": [84.90156187836811, -7.016645024697954, -12.4414176835282],
            "id": 14
        },
        {
            "name": "Palustrine Emergent Wetland",
            "color": [108, 159, 184, 255],
            "colorLab": [62.881597947799435, -10.37532934385288, -18.278483712930836],
            "id": 15
        },
        {
            "name": "Estuarine Forested Wetland",
            "color": [16, 16, 16, 255],
            "colorLab": [4.680422585088646, 0.0006367660824735388, -0.001259928546309963],
            "id": 16
        },
        {
            "name": "Estuarine Scrub/Shrub Wetland",
            "color": [17, 17, 17, 255],
            "colorLab": [5.063305411009324, 0.0006888568483687241, -0.00136299723156319],
            "id": 17
        },
        {
            "name": "Estuarine Emergent Wetland",
            "color": [18, 18, 18, 255],
            "colorLab": [5.463862478882593, 0.0007433521744398819, -0.001470823667115706],
            "id": 18
        },
        {
            "name": "Unconsolidated Shore",
            "color": [19, 19, 19, 255],
            "colorLab": [5.882319516224246, 0.0008002827706632409, -0.001583468616833672],
            "id": 19
        },
        {
            "name": "Bare Land",
            "color": [179, 172, 159, 255],
            "colorLab": [70.58867755227558, 0.21711674851321305, 7.569120302907617],
            "id": 20
        },
        {
            "name": "Open Water",
            "color": [70, 107, 159, 255],
            "colorLab": [44.689363333682095, 2.726848392493597, -32.13824482044061],
            "id": 21
        },
        {
            "name": "Palustrine Aquatic Bed",
            "color": [21, 21, 21, 255],
            "colorLab": [6.773815652389857, 0.0009215697894804364, -0.0018234515265946882],
            "id": 22
        },
        {
            "name": "Unknown",
            "color": [22, 22, 22, 255],
            "colorLab": [7.247286038154382, 0.0009859848881799138, -0.001950905585285101],
            "id": 23
        },
        {
            "name": "Unknown",
            "color": [23, 23, 23, 255],
            "colorLab": [7.739519325797062, 0.0010529526579677873, -0.002083410451941825],
            "id": 24
        },
        {
            "name": "Unknown",
            "color": [209, 222, 248, 255],
            "colorLab": [88.24470749634041, 0.8203879254597979, -14.127839427601984],
            "id": 25
        }
    ],
    landcoverGroups: {
        developed: () => {
            return [
                [0.2741734960237956, 0.00003730098721566044, -0.00007380509088883436],
                [35.31716164790645, 59.37904476315922, 49.64954217727144], //lab colors for id 2
                [49.08376319622447, 75.308367884784, 63.19157739919342], //lab colors for id 3
                [67.21786041864921, 24.911195700463796, 19.42586542012874], //lab colors for id 4
                [81.56200535099418, 8.793258917611679, 3.213993023308692] //lab colors for id 5
            ]
        },
        forests: () => {
            return [
                [64.07588071895144, -36.59818340061549, 32.52514425934094], //lab colors for id 9
                [35.22852855605888, -33.14472705345628, 23.078218389244153],//lab colors for id 10
                [77.12476884839018, -14.668221710120722, 25.33365271346979], //lab colors for id 11
                [3.6354946850715635, 0.0004946048495491073, -0.0009786431567682108],//lab colors for id 13
                [84.90156187836811, -7.016645024697954, -12.4414176835282],//lab colors for id 14
                [4.680422585088646, 0.0006367660824735388, -0.001259928546309963],//lab colors for id 16
                [5.063305411009324, 0.0006888568483687241, -0.00136299723156319]//lab colors for id 17
            ]
        },
        wetlands: () => {
            return [
                [3.6354946850715635, 0.0004946048495491073, -0.0009786431567682108],//lab colors for id 13
                [84.90156187836811, -7.016645024697954, -12.4414176835282],//lab colors for id 14
                [62.881597947799435, -10.37532934385288, -18.278483712930836],//lab colors for id 15
                [4.680422585088646, 0.0006367660824735388, -0.001259928546309963],//lab colors for id 16
                [5.063305411009324, 0.0006888568483687241, -0.00136299723156319],//lab colors for id 17
                [5.463862478882593, 0.0007433521744398819, -0.001470823667115706]//lab colors for id 18
            ]
        },
        agriculture: () => {
            return [
                [51.30878346260846, 19.363217847411796, 46.44166375918491],//lab colors for id 6
                [84.55415939983308, -16.598620443633582, 73.53887346183132]//lab colors for id 7
            ]
        }
    }
}